import { useEffect } from "react";

interface UseDocumentTitleOptions {
  /**
   * Title to restore when the component unmounts. If omitted, the hook
   * restores whatever `document.title` was when it first mounted.
   */
  defaultOnUnmount?: string;
}

/**
 * Imperatively sets `document.title` while the component is mounted.
 *
 * Pass `null` to leave the title untouched (useful while data is still
 * loading so the pestaña keeps the fallback from `index.html` instead of
 * flashing an intermediate value).
 */
export function useDocumentTitle(
  title: string | null,
  options?: UseDocumentTitleOptions,
): void {
  const defaultOnUnmount = options?.defaultOnUnmount;

  useEffect(() => {
    if (typeof document === "undefined") return;
    if (title === null || title === undefined) return;

    const previousTitle = document.title;
    document.title = title;

    return () => {
      document.title = defaultOnUnmount ?? previousTitle;
    };
  }, [title, defaultOnUnmount]);
}
